import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Menu } from 'lucide-react';
import { DialplanNodeData } from '@/types/dialplan-nodes';

export const IVRNode: React.FC<NodeProps<DialplanNodeData>> = ({ data, selected }) => {
  return (
    <div
      className={`
        px-4 py-3 rounded-lg border-2 bg-gradient-to-br from-cyan-50 to-cyan-100
        ${selected ? 'border-cyan-500 shadow-lg' : 'border-cyan-300 shadow'}
        min-w-[180px]
      `}
    >
      <Handle
        type="target"
        position={Position.Left}
        className="!bg-cyan-500 !w-3 !h-3"
      />

      <div className="flex items-center gap-2 mb-2">
        <Menu className="h-5 w-5 text-cyan-600" />
        <div className="flex-1">
          <div className="font-semibold text-cyan-900">{data.label}</div>
          {data.description && (
            <div className="text-xs text-cyan-700">{data.description}</div>
          )}
        </div>
        {!data.enabled && (
          <div className="px-2 py-0.5 bg-gray-200 text-gray-600 text-xs rounded">
            Disabled
          </div>
        )}
      </div>

      {data.dialplanConfig?.menuOptions && data.dialplanConfig.menuOptions.length > 0 && (
        <div className="text-xs text-cyan-700 mt-1">
          {data.dialplanConfig.menuOptions.length} menu option(s)
        </div>
      )}

      {data.priority !== undefined && (
        <div className="text-xs text-cyan-700 mt-1">
          Priority: {data.priority}
        </div>
      )}

      <Handle
        type="source"
        position={Position.Right}
        className="!bg-cyan-500 !w-3 !h-3"
      />
    </div>
  );
};

